import { config } from "../../config"
import { sha256 } from "../../helpers/jwt"

export const users = {
  postUser: async ({ token, username, rawPassword, role }) => {
    const hashedPassword = sha256(rawPassword)
    const url = config.apiUrl + `/users`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, hashedPassword, role }),
      }

    return { url, opt }
  },

  getAll: ({ token }) => {
    const url = config.apiUrl + `/users`,
      opt = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  delete: ({ token, user_id }) => {
    const url = config.apiUrl + `/users/${user_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  update: ({ token, user_id, user }) => {
    const url = config.apiUrl + `/users/${user_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...user }),
      }

    return { url, opt }
  },
}
